import React from "react";
import {
  ChartBarSquareIcon,
  BellAlertIcon,
  // ServerStackIcon,
  ExclamationTriangleIcon,
  DocumentTextIcon,
  MagnifyingGlassCircleIcon,
  BoltIcon,
  ClipboardDocumentListIcon,
  GlobeAltIcon,
} from "@heroicons/react/24/outline";
import { TabNavigation } from "../../ui";

export const SOC_TABS = [
  { id: "dashboard", label: "Dashboard", icon: ChartBarSquareIcon },
  { id: "alerts", label: "Alerts", icon: BellAlertIcon },
  // { id: "assets", label: "Assets", icon: ServerStackIcon },
  { id: "incidents", label: "Incidents", icon: ExclamationTriangleIcon },
  { id: "events", label: "Event Log", icon: DocumentTextIcon },
  { id: "investigations", label: "Investigations", icon: MagnifyingGlassCircleIcon },
  { id: "response", label: "Response", icon: BoltIcon },
  { id: "threat-intel", label: "Threat Intelligence", icon: GlobeAltIcon },
  { id: "reports", label: "Reports", icon: ClipboardDocumentListIcon },
];

// Horizontal tab bar - now the shared TabNavigation component (same one
// used by AI CRM / AI VAPT / Document Library) instead of a hand-rolled
// pill bar, for visual consistency across modules.
const Sidebar = ({ activeTab, onChange }) => (
  <TabNavigation
    tabs={SOC_TABS.map((tab) => ({ id: tab.id, name: tab.label, icon: tab.icon }))}
    activeTab={activeTab}
    onTabChange={onChange}
    boxedActive
  />
);

export default Sidebar;
